<!-- 登录组件 -->
<template>
    <div class="container" :class="{'container-bg':bgShow}" @click="closeWarn" v-if="isShow">
            <div class="dialog">
                <div class="model" >
                    <div class="head">
                        <img src="../../assets/img/login_logo.png" alt="">
                        <router-link tag="span" to="/">图库网</router-link>
                        <div class="mo-close" v-if="!bgShow" @click.stop="close">×</div>
                    </div>
                    <h3 class="title">登录</h3>
                    <form id="loginForm" autocomplete="off" name="loginform"  @keydown.enter="login">
                        <div class="input-box">
                            <img src="../../assets/img/login_per_icon.png" alt="" class="icon">
                            <input type="text" name="username" id="user" placeholder="请输入秒通工号" v-model="JobNo" required autofocus autocomplete="on">
                        </div>
                        <div class="input-box">
                            <img src="../../assets/img/login_pass_icon.png" alt="" class="icon">
                            <input type="password" name="password" id="Pwd"  placeholder="请输入秒通密码" v-model="Pwd" required autocomplete="new-password">
                        </div>
                        <div class="clearfix remember">
                            <label class="check fr"><input type="checkbox" :checked="isChecked" @click.stop="remember" id="checkbox"> 记住密码</label>
                        </div>
                        <div class="login" @click.stop="login">登录</div>
                    </form>
                </div>

            </div>
            <warn ref="warn"></warn>
            <div class="dialog" v-show="isLoadingShow">
                <div class="df loading">
                    <img src="../../assets/img/loading.gif" alt="">
                    <p>登录中<span class="animate-ellipse-box"><span class="animate-ellipse">...</span></span></p>
                </div>
            </div>   
    </div>
</template>
<script>
import { Base64 } from 'js-base64'
import Warn from "./warn.vue"
import { debug } from 'util';
export default {
    inject: ['reload'],
    props:{
        isShow:{
            type: Boolean,
            default:true
        },
        bgShow:{
           type: Boolean,
            default:true
        }
    },
    components: {
        Warn
    },
    data() {
        return {
            JobNo: "",   //账号
            Pwd: "", //密码
            isChecked: false,     //是否记住
            userInfo: {
                Id: "",
                Avatar: "",   //头像
                JobNo: "182904",    //工号
                Name: "王某",     //姓名
                NickName: "", //昵称
            },
            isLoadingShow: false,
        }
    },
    mounted() {
        if(this.isShow){
           this.getStorage()
        } 
    },
    methods: {
        getStorage(){
            this.JobNo = localStorage.getItem('username') || "";
            let pwd = localStorage.getItem(Base64.encode('password'));
            let isRemember = localStorage.getItem("isRemember");
            if(!pwd) return;
            this.Pwd = Base64.decode(pwd) || "";
            if (this.JobNo && this.Pwd && isRemember) {
                this.isChecked = true;
            }
        },
        //登录
        login(e) {
            if ((!this.JobNo ||  this.JobNo.length == 0) && (!this.Pwd || this.Pwd.length == 0)){
                this.$refs.warn.message("请填写工号和密码");
                return;
            }else if(!this.JobNo || this.JobNo.length == 0){
                this.$refs.warn.message("请填写工号");
                return;
            }else if(!this.Pwd || this.Pwd.length == 0){
                this.$refs.warn.message("请填写密码");
                return;
            }
            var that = this;
            this.isLoadingShow = true;
            let data = {
                'JobNo': this.JobNo,
                'Pwd': Base64.encode(this.Pwd)
            };
            this.$store.dispatch('user/login', data).then((res) => {
                localStorage.setItem("isRemember",that.isChecked);
                if (that.isChecked) {
                    localStorage.setItem('username', that.JobNo);
                    localStorage.setItem(Base64.encode('password'), Base64.encode(that.Pwd));
                } else {
                    localStorage.removeItem(Base64.encode('password'));
                    localStorage.removeItem("username");
                }
                this.saveToLocal(res);
                if(that.$route.path=="/login"){
                    that.$router.push({ path: that.redirect || "/" , query: that.query || {}});   
                    this.reload();
                }else{   
                    that.$emit('loginSuccess',true) ;
                    this.reload();
                }
            }).catch((error) => {
                that.$refs.warn.message(error+'  请使用秒通最新密码登录');
                that.isLoadingShow = false;
            })
        },
        saveToLocal(obj) {
            if (!obj) return;
            let userInfo = this.userInfo;
            Object.keys(userInfo).forEach((key) => {
                if (obj.hasOwnProperty(key)) {
                    this.userInfo[key] = obj[key];
                }
            })
            localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
        },
        remember(el) {
            this.isChecked = el.target.checked;
        },
        closeWarn() {
            this.$refs.warn.closeWarn();
        },
        // 关闭登录框
        close(){
             this.$emit('close',true)
        }
    },
    watch: {
        $route: {
            handler: function(route) {
                const query = route.query;
                if (query) {
                    this.redirect = query.redirect;
                    delete query.redirect;
                    this.query = query;
                }
            },
            immediate: true   //设置在监听成功时立即调用
        },
        "isShow":function(newVal){
            if(newVal){
                    this.getStorage();
            }
        }

    }
}
</script>
<style scoped>
.container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index:100000;

}
.container-bg{
    background: url(../../assets/img/login_bg.png) no-repeat;
    background-position: center center;
    background-size: cover;
}
.dialog {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .6);
}

.model {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 514px;
    height: 384px;
    margin: -192px 0 0 -257px;
    background-color: #fff;
    border-radius: 5px;
    color: #999;
    box-sizing: border-box;
    padding: 0 78px;
}

.head {
    position: absolute;
    left: 0;
    top: -57px;
    line-height: 38px;
    background: transparent;
    color: #fff;
    overflow: hidden;
    font-size: 34px;
     width: 514px;
}

.head img {
    vertical-align: middle;
}

.head span {
    margin-left: 20px;
    padding-left: 25px;
    opacity: 0.8;
    border-left: 1px solid #fff;
    cursor: pointer;
}
.mo-close{
    position: absolute;
    right: 0px;
    top:5px;
    font-size: 40px;
    line-height: 1;
    color: #fff;
    cursor: pointer;
}

.title {
    font-size: 22px;
    margin: 35px 0;
    text-align: center;
}

.input-box {
    position: relative;
    line-height: 50px;
    height: 50px;
    box-sizing: border-box;
    margin-bottom: 24px;
    border-radius: 25px;
}

.user-box {
    background: url(../../assets/img/login_per_icon.png) no-repeat;
    background-position: 40px 11px;
}

.pwd-box {
    background: url(../../assets/img/login_pass_icon.png) no-repeat;
    background-position: 40px 10px;
}

.input-box input {
    padding: 0 28px 0 90px;
    border: none;
    width: 240px;
    height: 100%;
    display: block;
    border-radius: 25px;
    border: 1px solid #e7e7e7;
}

.input-box .icon{
    position: absolute;
    left: 40px;
    top: 10px;
}
.login {
    display:block;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background-color: #ff9933;
    border-radius: 25px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    margin-top: 35px;
    cursor: pointer;
}

.login:hover {
    background-color: #ff8833;
}

.remember {
    font-size: 14px;
}

input[type=checkbox]:checked::after {
    top: 7px;
}
.loading{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-45%);
    color: #fff;
    flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/common/login.vue